import HTTP from '@/utils/http-common';

const config = { headers: { 'Content-Type': 'multipart/form-data' } };

const updateSupplier = (supplier) => HTTP.put(`/suppliers/${supplier._id}`, supplier);

const updateSupplierEndpoint = (endpoint) => HTTP.put('/suppliers/endpoints', endpoint);
const createSupplierEndpoint = (endpoint) => HTTP.post('/suppliers/endpoints', endpoint);
const deleteSupplierEndpoint = (endpointId) => HTTP.delete(`/suppliers/endpoints/${endpointId}`);
const updateSupplierDocument = (supplierId, document) => HTTP.put(`/suppliersdocuments/${document._id}`, document);
const uploadSupplierDocuments = (formData, supplierId, distributorId) =>
  HTTP.post(`/suppliers/${supplierId}/documents/${distributorId}`, formData, config);
const deleteSupplierDocuments = (documentId) => HTTP.delete(`/suppliers/documents/${documentId}`);

export const getMPowerDiscounts = async (supplierId) => (await HTTP.get(`/suppliers/${supplierId}/discounts`)).data;
export const updateMPowerDiscount = async (supplierId, discount) =>
  (await HTTP.put(`/suppliers/${supplierId}/discounts/${discount._id}`, discount)).data;
export const createMPowerDiscount = async (supplierId, discount) =>
  (await HTTP.post(`/suppliers/${supplierId}/discounts`, discount)).data;

export const getMPowerMarginDiscounts = async (supplierId) =>
  (await HTTP.get(`/suppliers/${supplierId}/margin-discounts`)).data;
export const updateMPowerMarginDiscount = async (supplierId, discount) =>
  (await HTTP.put(`/suppliers/${supplierId}/margin-discounts/${discount._id}`, discount)).data;
export const createMPowerMarginDiscount = async (supplierId, discount) =>
  (await HTTP.post(`/suppliers/${supplierId}/margin-discounts`, discount)).data;
export const removeMPowerMarginDiscount = async (supplierId, discount) =>
  await HTTP.delete(`/suppliers/${supplierId}/margin-discounts/${discount._id}`);

const getDiscounts = async (supplierId) => (await HTTP.get(`/dist-suppliers/${supplierId}/discounts`)).data;
const updateDiscount = async (supplierId, discount) =>
  (await HTTP.put(`/dist-suppliers/${supplierId}/discounts/${discount._id}`, discount)).data;
const createDiscount = async (supplierId, discount) =>
  (await HTTP.post(`/dist-suppliers/${supplierId}/discounts`, discount)).data;

const getMarginDiscounts = async (supplierId) =>
  (await HTTP.get(`/dist-suppliers/${supplierId}/margin-discounts`)).data;
const updateMarginDiscount = async (supplierId, discount) =>
  (await HTTP.put(`/dist-suppliers/${supplierId}/margin-discounts/${discount._id}`, discount)).data;
const createMarginDiscount = async (supplierId, discount) =>
  (await HTTP.post(`/dist-suppliers/${supplierId}/margin-discounts`, discount)).data;
const removeMarginDiscount = async (supplierId, discount) =>
  await HTTP.delete(`/dist-suppliers/${supplierId}/margin-discounts/${discount._id}`);
const syncWithAsi = async () => (await HTTP.post(`/suppliers/asi/sync`)).data;
const syncWithAsiProduct = async (asiNumber) => (await HTTP.post(`/suppliers/asi/sync/${asiNumber}`)).data;

const getDecorations = async (supplierId) => (await HTTP.get(`/suppliers/${supplierId}/decorations`)).data;

export const updateSupplierPlan = (supplierId, action, plan) =>
  HTTP.patch(`/suppliers/${supplierId}/plans`, { action, plan });

export {
  syncWithAsiProduct,
  createDiscount,
  updateDiscount,
  getDiscounts,
  updateSupplier,
  updateSupplierEndpoint,
  createSupplierEndpoint,
  deleteSupplierEndpoint,
  getMarginDiscounts,
  updateMarginDiscount,
  createMarginDiscount,
  removeMarginDiscount,
  syncWithAsi,
  updateSupplierDocument,
  uploadSupplierDocuments,
  deleteSupplierDocuments
};
